import { Component, EventEmitter, OnInit, Output } from '@angular/core'

@Component({
  selector: 'app-connect-airbnb-wizard-complete1',
  templateUrl: './connect-airbnb-wizard-complete1.component.html',
  styleUrls: ['./connect-airbnb-wizard-complete1.component.scss'],
})
export class ConnectAirbnbWizardComplete1Component implements OnInit {
  @Output() reset = new EventEmitter()
  @Output() channel = new EventEmitter()
  constructor() {}

  ngOnInit(): void {}
}
